export const footerStyleOverrides = {
  skippingLink: {
    marginLeft: 28,
  },
  cancelButton: {
    marginLeft: 12,
  },
};
